module.exports = __webpack_public_path__ + "static/media/star-black-yellow.66ba6ce8.svg";